export const genresData = [
	{ id: 10402, name: 'Music' },
	{ id: 10749, name: 'Romance' },
	{ id: 10751, name: 'Family' },
	{ id: 10752, name: 'War' },
	{ id: 10759, name: 'Action & Adventure' },
	{ id: 10762, name: 'Kids' },
	{ id: 10763, name: 'News' },
	{ id: 10764, name: 'Reality' }, // not taken
	{ id: 10765, name: 'Sci-Fi & Fantasy' },
	{ id: 10766, name: 'Soap' }, // not taken
	{ id: 10767, name: 'Talk' }, // not taken
	{ id: 10768, name: 'War & Politics' }, // not taken
	{ id: 10770, name: 'TV Movie' },
	{ id: 12, name: 'Adventure' },
	{ id: 14, name: 'Fantasy' },
	{ id: 16, name: 'Animation' },
	{ id: 18, name: 'Drama' },
	{ id: 27, name: 'Horror' },
	{ id: 28, name: 'Action' },
	{ id: 35, name: 'Comedy' },
	{ id: 36, name: 'History' },
	{ id: 37, name: 'Western' }, // not taken
	{ id: 53, name: 'Thriller' },
	{ id: 80, name: 'Crime' },
	{ id: 878, name: 'Science Fiction' },
	{ id: 9648, name: 'Mystery' }, // not taken
	{ id: 99, name: 'Documentary' },
];


// not taken: genres not added to site at present...